angular.module("avant.filters").filter "ReplaceNonnumericWithXes",
  -> (input) -> input.replace(/[^0-9]/g, 'X')
